// Los montos se muestran con dos decimales exactos. No se usa `roundingIncrement`
// porque redondea al múltiplo de 0.05 más cercano y altera el valor mostrado
// (ej.: 4384.32 se veía como 4384.30), desviándolo del monto real de la asignación.
const MONEY_FORMAT_OPTIONS: Intl.NumberFormatOptions = {
    style: "currency",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
};

let dollarUS = Intl.NumberFormat("en-US", {
    ...MONEY_FORMAT_OPTIONS,
    currency: "USD"
});

let euroSpanish = Intl.NumberFormat("es-ES", {
    ...MONEY_FORMAT_OPTIONS,
    currency: "EUR"
});

const FormatNumberMoney = (currency: string): Intl.NumberFormat => {
    let locale = "en-US"
    if (currency === "EUR"){
        locale = "es-ES"
    }
    return Intl.NumberFormat(locale, {
        ...MONEY_FORMAT_OPTIONS,
        currency: currency
    });
}

export {
    dollarUS, euroSpanish, FormatNumberMoney
}
